import config from 'baseConfig/pg/settlements';

import {
  STANDARD, 
  INSTANT, 
  VENDOR, 
  DROPDOWN,
  CHECKBOX,
  SETTLEMENTS_STATUS_ITEMS,
  SETTLEMENTS_TYPE_ITEMS,
} from 'baseConfig/pg/constants';

export default {
  [STANDARD]: {
    TABLE_COLUMNS: [...config[STANDARD]?.TABLE_COLUMNS],
    FILTER_ITEMS: {
      settlementStatus: {
        displayText: 'Status',
        type: DROPDOWN,
        items: SETTLEMENTS_STATUS_ITEMS,
      },
      settlementType: {
        displayText: 'Type',
        type: CHECKBOX,
        items: SETTLEMENTS_TYPE_ITEMS,
      },
    },
    SEARCH_ITEMS: [...config[STANDARD]?.SEARCH_ITEMS],
  },
  [INSTANT]: {
    TABLE_COLUMNS: [...config[INSTANT]?.TABLE_COLUMNS],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [VENDOR]: {
    TABLE_COLUMNS: [...config[VENDOR]?.TABLE_COLUMNS],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  VENDOR_FOR_SETTLEMENT_V2_UI: {
    TABLE_COLUMNS: [...config['VENDOR_FOR_SETTLEMENT_V2_UI']?.TABLE_COLUMNS],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  }
};
